// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1tjZK","large":"styles_large__9-OR4"};